import { User as IUser } from "@/api/models/user";
import router from "@/router";

export default {
  state: {
    selectedUser: {}
  },
  actions: {
    SETUP_SELECTED_USER(ctx: any, user: IUser) {
      ctx.commit("SETUP_SELECTED_USER", user);
    },
    GO_TO_USER_PAGE(ctx: any, user: IUser) {
      ctx.commit("SETUP_SELECTED_USER", user);
      router.push({
        name: "userProfileView",
        params: {
          id: user.id
        }
      });
    }
  },
  mutations: {
    SETUP_SELECTED_USER(state: any, user: IUser) {
      state.selectedUser = user;
    }
  },
  getters: {
    SELECTED_USER(state: any) {
      return state.selectedUser;
    }
  }
};
